import React from 'react'
import styled from 'styled-components'

const Image = styled.img`
	width: 100%;
	vertical-align: bottom;
	cursor: zoom-in;
`

const ToolTip = styled.div`
	background: black;
	padding: 1rem;
	color: white;
	position: absolute;
	z-index: 2;
	text-transform: capitalize;
`

class Artwork extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			mouseX: 0,
			mouseY: 0,
			isVisbile: false,
			isBig: false
		}

		this.onHover      = this.onHover.bind(this)
		this.onMouseOver  = this.onMouseOver.bind(this)
		this.onMouseLeave = this.onMouseLeave.bind(this)
		this.onClick      = this.onClick.bind(this)

	}

	onHover(e) {
		this.setState({ mouseX: e.clientX + 20, mouseY: e.clientY + 20 + window.pageYOffset});
	}

	onMouseOver() {
		this.setState({isVisbile: true})
	}

	onMouseLeave() {
		this.setState({isVisbile: false})
	}

	onClick() {
		if(window.innerWidth <= 719) {
			return;
		}
		this.setState({isBig: !this.state.isBig})
	}

	render() {
		const {srcSet, alt, name} = this.props;
		const {mouseY, mouseX, isVisbile, isBig} = this.state;
		return (
			<div style={{
				gridColumn: isBig ? 'span 2' : 'span 1',
				gridRow: isBig ? 'span 2' : 'span 1',
			}}>
				<Image 
					style={{cursor: isBig ? 'zoom-out' : 'zoom-in'}} 
					onClick={this.onClick} 
					onMouseOver={this.onMouseOver} 
					onMouseLeave={this.onMouseLeave} 
					onMouseMove={this.onHover} 
					srcset={srcSet.srcSet} 
					sizes={srcSet.sizes} 
					src={srcSet.src} 
					alt={alt}
				/>
				<ToolTip style={{top: mouseY, left: mouseX, display: isVisbile ? 'block' : 'none'}} >{name}</ToolTip>
			</div>
		)
	}
}

export default Artwork



// WEBPACK FOOTER //
// ./src/components/artwork.js